import { Checkbox } from "@mui/material";
import React from "react";
import { Box } from "@mui/material";
import { useBoundStore } from "useStore";
import { useShallow } from "zustand/react/shallow";

export default function CustomCheckbox(props) {
  const isChecked = useBoundStore(
    useShallow((state) => !!state.cmEditedRows[props.row.id]),
  );
  const toggleCmEditedRow = useBoundStore((state) => state.toggleCmEditedRow);
  const handleToggle = () => {
    toggleCmEditedRow(props.row.id, props.row);
  };
  return (
    <Box>
      <Checkbox
        checked={isChecked}
        onChange={handleToggle}
        sx={{
          p: 0,
          "&.Mui-checked": {
            color: "#002878",
          },
          "&.MuiCheckbox-indeterminate": {
            color: "#002878",
          },
        }}
      />
    </Box>
  );
}
